var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { ref: "contextMenu", staticClass: "contextmenu" }, [_vm._l(_vm.menuList, function (item, index) {
    return _c('div', { key: index, staticClass: "contextmenu-item", on: { "click": function click($event) {
          $event.stopPropagation();return _vm.menuHandler(item);
        } } }, [_vm._v("\n    " + _vm._s(item.name) + "\n  ")]);
  }), _vm._v(" "), _vm.colorMenu ? _c('div', { staticClass: "color-container" }, [_c('div', { staticClass: "layer-color-title" }, [_vm._v("\n      " + _vm._s(_vm.$t('workbench.layerManager.layerColor')) + "\n    ")]), _vm._v(" "), _vm._l(_vm.colorMenu, function (item, index) {
    return _c('div', { key: index, staticClass: "contextmenu-item", on: { "click": function click($event) {
          $event.stopPropagation();return _vm.menuHandler(item);
        } } }, [_c('pt-icon', { attrs: { "size": 14, "color": item.color } }, [_c(item.icon, { tag: "component" })], 1), _vm._v("\n      " + _vm._s(item.name) + "\n    ")], 1);
  })], 2) : _vm._e()], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };